import { render, staticRenderFns } from "./NoComp.vue?vue&type=template&id=32eedaa8"
import script from "./NoComp.vue?vue&type=script&lang=js"
export * from "./NoComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports